import React from 'react';
import './Messages.css';
import Message from '../Message/Message';
import ScrollToBottom from 'react-scroll-to-bottom';

const Messages = ({ messages,name }) => {
    if(messages)
    {
        console.log(Messages);
    }
    return (
        <ScrollToBottom className="messages">
        {
            messages.map((message,i)=><div key={i}><Message message={message} name={name}></Message></div>)
        }
        </ScrollToBottom>
        
    );
};

export default Messages;